<template>
  <Portal to="app-dialog">
    <VModal ref="modal" @modal:hidden="$emit('close')" disable-backdrop-click>
      <div class="w-full max-w-lg mx-auto">
        <div class="mb-4">
          <div class="flex items-center justify-end">
            <div class="flex-none" @click.stop>
              <button
                class="h-10 w-10 inline-flex items-center justify-center bg-white hover:bg-gray-200 focus:outline-none rounded-full"
                @click="$refs.modal.close()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                  <path
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                      4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                      4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                      5.636z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="rounded shadow-xs w-full max-w-6xl mx-auto" @click.stop>
          <div class="rounded shadow-lg bg-white overflow-hidden">
            <div class="px-4 sm:px-6 py-5 border-b">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <h1 class="text-sm">Edit pipeline stage</h1>
                </div>
              </div>
            </div>
            <template>
              <div class="p-4 sm:p-6 space-y-8">
                <BaseFormGroup>
                  <BaseFormLabel for="pipeline-stage-name"> Pipeline stage name </BaseFormLabel>
                  <BaseFormInput id="pipeline-stage-name" v-model="formData.name" />
                </BaseFormGroup>

                <BaseFormGroup>
                  <BaseFormLabel for="pipeline-stage-description">
                    Pipeline stage description
                  </BaseFormLabel>
                  <VTextEditor
                    :content="formData.description"
                    @change="formData.description = $event"
                  />
                </BaseFormGroup>
              </div>
              <div class="p-4 sm:p-6 bg-gray-100">
                <div class="flex space-x-2">
                  <BaseButton
                    type="button"
                    primary
                    :disabled="!isValid"
                    @click="updatePipelineStage"
                  >
                    Update pipeline stage
                  </BaseButton>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </VModal>
  </Portal>
</template>

<script>
import { pick } from 'lodash-es';
import VTextEditor from 'Components/Common/VTextEditor.vue';

const props = {
  pipelineStage: {
    type: Object,
    required: true,
  },
};

function data() {
  return {
    formData: {
      ...pick(this.pipelineStage, ['name', 'description']),
    },
  };
}

const computed = {
  isValid() {
    return this.formData.name.length > 0;
  },
};

const methods = {
  updatePipelineStage() {
    this.$emit('update', this.formData);
  },
};

export default {
  components: { VTextEditor },
  props,
  data,
  computed,
  methods,
};
</script>
